export default __webpack_public_path__ + "static/media/header-img.83b9cb58.png";